import PropTypes from "prop-types";
import { useState } from "react";
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
// import { useGeolocated } from "react-geolocated";
import MapPicker from "react-google-map-picker";

import {
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
  Grid,
} from "@mui/material";
import MDButton from "components/MDButton";

function GeoLocationMapPoint({ displayName, fieldRef, isOptional, options }) {
  console.log(options ? "" : "");
  const [fieldError, showFieldError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const [gpsLocationCoords, setGpsLocationCoords] = useState(null);
  const [location, setLocation] = useState({});
  const [openMapDialog, setOpenMapDialog] = useState(false);

  function onLocationSuccess(position) {
    // console.log("KBJBD");
    // console.log(position.coords.accuracy);
    setLocation({
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    });
    setGpsLocationCoords(null);
    setOpenMapDialog(true);
  }

  function getGPSCoords() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(onLocationSuccess, null, {
        enableHighAccuracy: true,
        timeout: 50000,
      });
    } else {
      setErrorMsg(
        "Unable to retrieve your current location. Make sure Location permissions are allowed on your browser."
      );
      showFieldError(true);
    }
    return false;
  }

  function onLocationPicked(clat, clng) {
    setLocation({ lat: clat, lng: clng });
  }

  function captureLocation() {
    if (location) {
      setGpsLocationCoords(
        JSON.stringify({
          latitude: location.lat,
          longitude: location.lng,
        })
      );
    }
  }

  // console.log(options);
  return (
    <MDBox mt={3}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openMapDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Pick (Drag) Location</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            {location ? (
              <div style={{ height: "75vh", width: "100%" }}>
                <MapPicker
                  defaultLocation={location}
                  zoom={14}
                  mapTypeId="roadmap"
                  style={{ height: "75vh" }}
                  onChangeLocation={(lat, lng) => {
                    onLocationPicked(lat, lng);
                  }}
                  // onChangeZoom={handleChangeZoom}
                  apiKey="AIzaSyCmiv_wy1kjzBT6tcvMK56pdhfpG32Ljw0"
                />
              </div>
            ) : (
              <> </>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenMapDialog(false);
            }}
            color="dark"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>close</Icon>
          </MDButton>
          &nbsp;
          <MDButton
            color="info"
            variant="outlined"
            iconOnly
            circular
            onClick={() => {
              captureLocation();
              setOpenMapDialog(false);
            }}
          >
            <Icon>save</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox>
        <Grid container spacing={3}>
          <Grid item xs={8} md={8} lg={8}>
            <MDTypography variant="h6" fontWeight="light" fontSize="small" mb={2}>
              {displayName}
            </MDTypography>
          </Grid>
          <Grid item xs={4} md={4} lg={4}>
            <MDBox align="right">
              <MDButton
                iconOnly
                size="small"
                variant="contained"
                color="primary"
                // startIcon={<Icon>location_on</Icon>}
                onClick={() => {
                  getGPSCoords();
                }}
              >
                <Icon>location_on</Icon>
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox>
        {gpsLocationCoords !== null && location ? (
          <MDTypography variant="caption" fontSize={14} fontWeight="light">
            <b>
              <Icon color="error">pin_drop</Icon>&nbsp;GPS Captured
            </b>
            <br />
            <small>
              Latitude: {location.lat} | Longitude: {location.lng}
            </small>
          </MDTypography>
        ) : (
          <> </>
        )}
      </MDBox>
      <input type="hidden" id={`dff_${fieldRef}`} name={`${fieldRef}`} value={gpsLocationCoords} />
    </MDBox>
  );
}

// Typechecking props of the Transaction
GeoLocationMapPoint.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

GeoLocationMapPoint.defaultProps = {
  options: null,
};

export default GeoLocationMapPoint;
